import { InteractionTypeEnum, Resource } from "@examspark/types";

const supportedInteractionTypes: string[] = [InteractionTypeEnum.Choice];

export const itemSupportsResponseMasking = (item: Resource) => {
  return (
    item.content?.canvas?.some((canvas) => {
      return (
        canvas?.interactionType &&
        supportedInteractionTypes.includes(canvas.interactionType)
      );
    }) ?? false
  );
};
